<template>
  <v-container fluid class="item-edit mt-3 mx-1">
    <v-row>
      <v-col cols="12" centered>
        <v-tabs
          color="primary"
        >
          <v-tabs-slider></v-tabs-slider>

          <v-tab
            :href="`#tab-item`"
            class="mr-5"
          >
            <v-icon class="mr-3">mdi-label</v-icon>
            Item
          </v-tab>
          <v-tab
            class="mr-5"
            :href="`#tab-images`"
          >
            <v-icon class="mr-3">mdi-image-multiple</v-icon>
            Images
          </v-tab>
          <v-tab
            class="mr-5"
            :href="`#tab-photo`"
          >
            <v-icon class="mr-3">mdi-camera</v-icon>
            Photo
          </v-tab>
          <v-tab
            class="mr-5"
            :href="`#tab-prices`"
          >
            <v-icon class="mr-3">mdi-currency-usd</v-icon>
            Prices
          </v-tab>
          <v-tab
            class="mr-5"
            :href="`#tab-details`"
          >
            <v-icon class="mr-3">mdi-shape</v-icon>
            Details
          </v-tab>

          <v-tab-item
            :value="'tab-item'"
          >
            <v-card
              elevation="0"
              flat
              tile
            >
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="3" sm="6">
                    <v-form>
                      <p class="text-h5">Edit Item</p>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'itemnum')"
                        v-bind:value="edit_item.itemnum"
                        placeholder="Item Num"
                        persistent-hint
                        single-line hint="Enter the item num">
                      </v-text-field>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'itemname')"
                        v-bind:value="edit_item.itemname"
                        placeholder="Item Name"
                        persistent-hint
                        single-line hint="Enter the item name">
                      </v-text-field>

                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'itemsalesdesc')"
                        v-bind:value="edit_item.itemsalesdesc"
                        placeholder="Item Sales Desc"
                        persistent-hint
                        single-line hint="Enter the sales description">
                      </v-text-field>
                      <v-select
                        class="mb-4"
                        :items=itemtype
                        :value="edit_item.itemtype"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'itemtype')"
                        placeholder="Type"
                        persistent-hint
                        single-line hint="Please choose the item type">
                      </v-select>
                      <v-switch
                          color="primary"
                          v-on:change="updateChangedValue($event, 'itemstatus')"
                          v-bind:label="edit_item.itemstatus=='Active' ? 'Active' : 'Inactive'"
                          v-bind:value="edit_item.itemstatus"
                          v-model="edit_item.itemstatus"
                          true-value="Active"
                          false-value="Inactive"
                      ></v-switch>
                    </v-form>
                  </v-col>
                  <v-col cols="12" md="3" sm="6">
                    <v-form>
                      <p class="text-h5">&nbsp;</p>
                      <v-select
                        class="mb-4"
                        :items="brands.map(x => {
                            return {text: x.brandname, value: x._id};
                          })"
                        :value="edit_item.brandid"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'brandid')"
                        placeholder="Brand"
                        persistent-hint
                        single-line hint="Please choose the brand">
                      </v-select>
                      <v-select
                        class="mb-4"
                        :items="itemgroups.map(x => {
                            return {text: x.itemgroupname, value: x._id};
                          })"
                        :value="edit_item.itemgroupid"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'itemgroupid')"
                        placeholder="Item Group"
                        persistent-hint
                        single-line hint="Please choose the item group">
                      </v-select>
                      <v-select
                        class="mb-4"
                        :items="itemcategories.map(x => {
                            return {text: x.itemcategoryname, value: x._id};
                          })"
                        :value="edit_item.itemcategoryid"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'itemcategoryid')"
                        placeholder="Item Category"
                        persistent-hint
                        single-line hint="Please choose the item category">
                      </v-select>
                      <v-select
                        class="mb-4"
                        :items="itemsubcategories.map(x => {
                            return {text: x.itemsubcategoryname, value: x._id};
                          })"
                        :value="edit_item.itemsubcategoryid"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'itemsubcategoryid')"
                        placeholder="Item Subcategory"
                        persistent-hint
                        single-line hint="Please choose the item subcategory">
                      </v-select>
                    </v-form>
                  </v-col>
                  <v-col cols="12" md="3" sm="6">
                    <v-form>
                      <p class="text-h5">&nbsp;</p>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'itemsize')"
                        v-bind:value="edit_item.itemsize"
                        placeholder="Item Size"
                        persistent-hint
                        single-line hint="Enter the item size">
                      </v-text-field>
                      <v-text-field
                        class="mb-4"
                        type="number"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'itemcost')"
                        v-bind:value="edit_item.itemcost"
                        placeholder="Item Cost"
                        persistent-hint
                        single-line hint="Enter the default item cost">
                      </v-text-field>
                      <v-text-field
                        class="mb-4"
                        type="number"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'itemweight')"
                        v-bind:value="edit_item.itemweight"
                        placeholder="Item Weight"
                        persistent-hint
                        single-line hint="Enter the item weight (kg)">
                      </v-text-field>
                      <v-text-field
                        class="mb-4"
                        type="number"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'itemvolume')"
                        v-bind:value="edit_item.itemvolume"
                        placeholder="Item Volume"
                        persistent-hint
                        single-line hint="Enter the item volume (cbm)">
                      </v-text-field>
                    </v-form>
                  </v-col>
                  <v-col cols="12" md="3" sm="6">
                    <v-form>
                      <p class="text-h5">&nbsp;</p>
                      <v-select
                        class="mb-4"
                        :items=units
                        :value="edit_item.itemunit"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'itemunit')"
                        placeholder="Primary Unit"
                        persistent-hint
                        single-line hint="Please choose the primary unit">
                      </v-select>
                      <v-select
                        class="mb-4"
                        :items=units
                        :value="edit_item.itemunit2"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'itemunit2')"
                        placeholder="Secondary Unit"
                        persistent-hint
                        single-line hint="Please choose the secondary unit">
                      </v-select>
                      <v-text-field
                        class="mb-4"
                        type="number"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'itemconvert')"
                        v-bind:value="edit_item.itemconvert"
                        placeholder="Conversion"
                        persistent-hint
                        single-line hint="Enter the item conversion rate">
                      </v-text-field>
                    </v-form>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="12" sm="12">
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/item/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="editItem()">
                            Save
                          </v-btn>
                      </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item :value="'tab-images'">
            <ImageEditView :id="initvalue._id" :route="`item`" :images="initvalue.images" />
          </v-tab-item>
          <v-tab-item
              :value="'tab-photo'"
          >
            <v-card
                flat
                tile
            >
              <v-card-text>

                <v-row justify="center">
                  <v-col cols="12" md="6">
                    <v-form>
                      <p class="text-h5">Upload Photo</p>
                        <v-file-input label="File input" v-on:change="onFileChange" accept="image/*" />
                        <v-img contain max-height="150" max-width="250" :src="imageurl" />
                        <v-spacer min-height="20">&nbsp;</v-spacer>
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/item/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="editPhoto()">
                            Save
                          </v-btn>
                      </div>
                    </v-form>
                  </v-col>
                </v-row>

              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item :value="'tab-prices'">
            <v-card elevation="0" flat tile>
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <v-row>
                      <v-col md="11">
                        <p class="text-h5">Prices</p>
                      </v-col>
                      <v-col md="1">
                        <v-btn
                          class="button-shadow"
                          color="secondary"
                          @click="addPriceDialog"
                        >
                          Add
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-form>
                      <v-data-table
                        :headers="priceHeaders"
                        :items="itemprices"
                        :items-per-page="100"
                        class="elevation-0"
                      >
                        <template v-slot:top>
                          <v-dialog v-model="isDeletePrice" width="500">
                            <v-card>
                              <v-card-title> Delete this Price? </v-card-title>
                              <v-card-text>
                                {{ deleteprice.pricename }}
                              </v-card-text>
                              <v-divider></v-divider>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="primary"
                                  outlined
                                  @click="isDeletePrice = false"
                                  >Cancel</v-btn
                                >
                                <v-btn
                                  color="secondary"
                                  class="button-shadow"
                                  @click="deletePrice(deleteprice)"
                                  >Delete
                                </v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </template>
                        <template v-slot:item.itemid="{ item }">
                          {{ items.length!==0 ? items.find(i=>i._id == item.itemid)['itemname'] : ''  }}
                        </template>
                        <template v-slot:item.pricelistid="{ item }">
                          <p v-if="item" class="two-line">{{ item.pricelistid!=null && pricelists.length!==0 ? pricelists.find(pricelist=>pricelist._id == item.pricelistid)['pricelistname'] : ''  }}</p>
                          <p v-if="item" class="two-line"><a class="primaryConst--text">{{ item.pricename }}</a></p>
                        </template>
                        <template v-slot:item.minqty="{ item }">
                          <p v-if="item" class="two-line">{{ item.minqty }}</p>
                          <p v-if="item" class="two-line">{{ item.maxqty  }}</p>
                        </template>  
                        <template v-slot:item.listprice="{ item }">
                          <p v-if="item" class="two-line">{{ item.listprice }} {{ item.currency }}</p>
                          <p v-if="item" class="two-line">per {{ item.unit  }}</p>
                        </template>        
                        <template v-slot:item.foc="{ item }">
                          <div v-if="item.foc!=null && item.foc.enable==true">
                            <p v-if="item.foc.itemqty && item.foc.getitemqty" class="two-line"><span style="font-size: 10pt; font-weight: bold;">Buy:</span> {{ item.foc.itemqty }} x {{ items.length!==0 ? items.find(i=>i._id == item.itemid)['itemname'] : ''  }}</p>
                            <p v-if="item.foc.itemid" class="two-line"><span style="font-size: 10pt; font-weight: bold;">Get:</span> {{ item.foc.getitemqty !=null ? item.foc.getitemqty.toFixed(4) : 0 }} x {{ items.length!==0 ? items.find(i=>i._id == item.foc.itemid)['itemname'] : ''  }}</p>
                            <p v-if="item.foc.itemsubcategoryid!=null" class="two-line"><span style="font-size: 10pt; font-weight: bold;">Get Group:</span> {{ itemsubcategories.length!==0 && itemsubcategories.find(i=>i._id == item.foc.itemsubcategoryid)!=null ? itemsubcategories.find(i=>i._id == item.foc.itemsubcategoryid)['itemsubcategoryname'] : ''  }}</p>
                          </div>
                        </template>               
                        <template v-slot:item.createdAt="{ item }">
                          <p v-if="item" class="two-line">{{ new Date(item.createdAt).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}</p>
                        </template>
                        <template v-slot:item.actions="{ item }">

                          <v-tooltip bottom>
                            <template #activator="{ on }">
                              <v-btn
                                icon
                                v-on="on"
                                color="primary"
                                @click="editItemPriceDialog(item)"
                              >
                                <v-icon>mdi-pencil</v-icon>
                              </v-btn>
                            </template>
                            <span>Edit Price</span>
                          </v-tooltip>
                          <v-tooltip bottom>
                            <template #activator="{ on }">
                              <v-btn 
                                icon 
                                v-on="on"
                                color="primary"
                                @click="editItemFocDialog(item)"
                              >
                                <v-icon>mdi-playlist-edit</v-icon>
                              </v-btn>
                            </template>
                            <span>Edit FOC</span>
                          </v-tooltip>
                          <v-btn
                            icon
                            color="primary"
                            @click="deletePriceDialog(item)"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </template>
                      </v-data-table>
                    </v-form>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <div class="d-flex justify-center">
                      <v-btn
                        to="/item/list"
                        replace
                        outlined
                        color="primary"
                      >
                        Done
                      </v-btn>
                      <v-spacer></v-spacer>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item :value="'tab-details'">
            <v-card elevation="0" flat tile>
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <v-row>
                      <v-col md="11">
                        <p class="text-h5">Item Details</p>
                      </v-col>
                      <v-col md="1">
                        <v-btn
                          class="button-shadow"
                          color="secondary"
                          @click="isAddDetail=true; upload={}; uploadname=null;"
                        >
                          Add
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-form>
                      <v-data-table
                        sort-by="detailrank"
                        :headers="detailHeaders"
                        :items="itemdetails"
                        :items-per-page="500"
                        :footer-props="footer"
                        class="elevation-0"
                      >
                        <template v-slot:top>
                          <v-dialog v-model="isDeleteDetail" width="500">
                            <v-card>
                              <v-card-title> Delete this Detail? </v-card-title>
                              <v-card-text>
                                {{ deletedetail.detailrank }}
                              </v-card-text>
                              <v-divider></v-divider>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="primary"
                                  outlined
                                  @click="isDeleteDetail = false"
                                  >Cancel</v-btn
                                >
                                <v-btn
                                  color="secondary"
                                  class="button-shadow"
                                  @click="deleteDetail(deletedetail)"
                                  >Delete
                                </v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </template>
                        <template v-slot:item.detailbody="{ item }">
                          <p class="two-line" v-html="item.detailbody"></p>
                          <img v-if="item.detailimage" v-bind:src="item.detailimage" alt="">
                        </template>                        
                        <template v-slot:item.createdAt="{ item }">
                          {{
                            new Date(item.createdAt).toLocaleString("en-SG", {
                              year: "numeric",
                              month: "numeric",
                              day: "numeric",
                            })
                          }}
                        </template>
                        <template v-slot:item.actions="{ item }">
                          <v-btn
                            icon
                            color="primary"
                            @click="editDetailRequest(item)"
                          >
                            <v-icon>mdi-pencil</v-icon>
                          </v-btn>
                          <v-btn
                            icon
                            color="primary"
                            @click="deleteDetailDialog(item)"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </template>
                      </v-data-table>
                    </v-form>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <div class="d-flex justify-center">
                      <v-btn
                        to="/item/list"
                        replace
                        outlined
                        color="primary"
                      >
                        Done
                      </v-btn>
                      <v-spacer></v-spacer>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-dialog
        v-model="isAddDetail"
        persistent
        width="800px"
        max-width="800px"
      >
      <v-card>
        <v-card-title>
          <span class="text-h5">Add Detail</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" md="2">
                <v-text-field
                  v-model="detail.detailrank"
                  class="mb-4"
                  placeholder="Num"
                  type="number"
                  oninput="if(this.value < 1) this.value = 1;"
                  single-line
                  hint="Num"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="8">
                <v-file-input outlined dense label="File input" v-model="uploadname" v-on:change="onDetailFileChange" accept="image/*" />     
              </v-col>
              <v-col cols="12" md="12">
                 <vue-editor v-model="detail.detailbody"></vue-editor>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="isAddDetail = false"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="addItemDetail"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
  <v-row justify="center">
    <v-dialog
          v-model="isAddPrice"
          persistent
          width="800px"
          max-width="800px"
        >
          <v-card>
          <v-card-title>
            <span class="text-h5">Add Price</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" md="6">
                    <v-form>
                      <v-select
                        class="mb-4"
                        outlined
                        dense
                        persistent-hint
                        placeholder="Price List"
                        single-line hint="Please choose the price list"
                        :items="pricelists.length>0 ? pricelists.map(x => {
                            return {text: x.pricelistname, value: x._id};
                          }) : []"
                        v-model="addprice.pricelistid"
                        v-bind:error="errorindex == 20"
                      >
                      </v-select>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        placeholder="Price Name"
                        persistent-hint
                        single-line hint="Enter the price name"
                        v-model="addprice.pricename"
                        v-bind:error="errorindex == 21"
                      >
                      </v-text-field>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        persistent-hint
                        placeholder="Currency"
                        v-model="addprice.currency"
                        v-bind:error="errorindex == 22"
                        single-line hint="Enter the currency"
                      >
                      </v-text-field>
                      <v-select
                        class="mb-4"
                        outlined
                        dense
                        persistent-hint
                        placeholder="Unit"
                        single-line hint="Please choose the unit"
                        :items="[initvalue.itemunit,  initvalue.itemunit2]"
                        v-model="addprice.unit"
                        v-bind:error="errorindex == 23"
                      >
                      </v-select>
                    </v-form>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                        class="mb-4"
                        type="number"
                        outlined
                        dense
                        placeholder="Min Qty"
                        persistent-hint
                        single-line hint="Enter the minimum quantity"
                        v-model="addprice.minqty"
                        v-bind:error="errorindex == 24"
                      >
                      </v-text-field>
                      <v-text-field
                        class="mb-4"
                        type="number"
                        outlined
                        dense
                        placeholder="Max Qty"
                        persistent-hint
                        single-line hint="Enter the maximum quantity"
                        v-model="addprice.maxqty"
                        v-bind:error="errorindex == 25"
                      >
                      </v-text-field>
                      <v-text-field
                        class="mb-4"
                        type="number"
                        outlined
                        dense
                        placeholder="List Price"
                        persistent-hint
                        single-line hint="Enter the list price"
                        v-model="addprice.listprice"
                        v-bind:error="errorindex == 26"
                      >
                      </v-text-field>
                  </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isAddPrice = false"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="addPrice"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    <v-dialog
          v-model="isEditPrice"
          persistent
          width="800px"
          max-width="800px"
        >
          <v-card>
          <v-card-title>
            <span class="text-h5">Edit Price</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" md="6">
                    <v-form>
                      <v-select
                        class="mb-4"
                        :items="pricelists.length>0 ? pricelists.map(x => {
                            return {text: x.pricelistname, value: x._id};
                          }) : []"
                        :value="editprice.pricelistid"
                        outlined
                        dense
                        v-on:change="editOnChangePrice($event, 'pricelistid')"
                        placeholder="Price List"
                        persistent-hint
                        single-line hint="Please choose the price list">
                      </v-select>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="editOnChangePrice($event, 'pricename')"
                        v-bind:value="editprice.pricename"
                        placeholder="Price Name"
                        persistent-hint
                        single-line hint="Enter the price name">
                      </v-text-field>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="editOnChangePrice($event, 'currency')"
                        v-bind:value="editprice.currency"
                        placeholder="Currency"
                        persistent-hint
                        single-line hint="Enter the currency">
                      </v-text-field>
                      <v-select
                        class="mb-4"
                        :items="[initvalue.itemunit,  initvalue.itemunit2]"
                        :value="editprice.unit"
                        outlined
                        dense
                        v-on:change="editOnChangePrice($event, 'unit')"
                        placeholder="Unit"
                        persistent-hint
                        single-line hint="Please choose the unit">
                      </v-select>
                    </v-form>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                        class="mb-4"
                        type="number"
                        outlined
                        dense
                        v-on:change="editOnChangePrice($event, 'minqty')"
                        v-bind:value="editprice.minqty"
                        placeholder="Min Qty"
                        persistent-hint
                        single-line hint="Enter the minimum quantity">
                      </v-text-field>
                      <v-text-field
                        class="mb-4"
                        type="number"
                        outlined
                        dense
                        v-on:change="editOnChangePrice($event, 'maxqty')"
                        v-bind:value="editprice.maxqty"
                        placeholder="Max Qty"
                        persistent-hint
                        single-line hint="Enter the maximum quantity">
                      </v-text-field>
                      <v-text-field
                        class="mb-4"
                        type="number"
                        outlined
                        dense
                        v-on:change="editOnChangePrice($event, 'listprice')"
                        v-bind:value="editprice.listprice"
                        placeholder="List Price"
                        persistent-hint
                        single-line hint="Enter the list price">
                      </v-text-field>
                  </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isEditPrice = false"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="editItemPrice"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
          v-model="isEditFoc"
          persistent
          width="800px"
          max-width="800px"
        >
          <v-card>
          <v-card-title>
            <span class="text-h5">Edit Foc</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field
                        class="mb-4"
                        type="number"
                        outlined
                        dense
                        v-on:change="editOnChangeFoc($event, 'itemqty')"
                        v-bind:value="editfoc.foc.itemqty"
                        placeholder="Item Qty"
                        persistent-hint
                        single-line hint="Enter the purchase item quantity">
                      </v-text-field>
                      <v-text-field
                        class="mb-4"
                        type="number"
                        outlined
                        dense
                        v-on:change="editOnChangeFoc($event, 'getitemqty')"
                        v-bind:value="editfoc.foc.getitemqty"
                        placeholder="FOC Item Qty"
                        persistent-hint
                        single-line hint="Enter the FOC item quantity">
                      </v-text-field>
                      <v-switch
                        v-model="editfoc.foc.enable"
                        v-on:change="editOnChangeFoc($event, 'enable')"
                        v-bind:label="editfoc.foc.enable==true ? 'true' : 'false'"
                        :value="editfoc.foc.enable"
                        :true-value="true"
                        :false-value="false"
                      ></v-switch>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-form>
                      <v-select
                        class="mb-4"
                        :items=foctype
                        :value="editfoc.foc.type"
                        outlined
                        dense
                        v-on:change="editOnChangeFoc($event, 'type')"
                        placeholder="FOC Item Type"
                        persistent-hint
                        single-line hint="Please choose the FOC Item Type">
                      </v-select>
                      <v-select
                        class="mb-4"
                        :items="[
                          {text: 'None', value: null},
                          ...items.map(x => {return {text: x.itemname, value: x._id}})
                        ]"
                        :value="editfoc.foc.itemid"
                        outlined
                        dense
                        v-on:change="editOnChangeFoc($event, 'itemid')"
                        placeholder="Item"
                        persistent-hint
                        single-line hint="Please choose the FOC item">
                      </v-select>
                      <v-select
                        class="mb-4"
                        :items="[
                          {text: 'None', value: null},
                          ...itemsubcategories.map(x => {return {text: x.itemsubcategoryname, value: x._id}})
                        ]"
                        :value="editfoc.foc.itemsubcategoryid"
                        outlined
                        dense
                        v-on:change="editOnChangeFoc($event, 'itemsubcategoryid')"
                        placeholder="Item Subcategory"
                        persistent-hint
                        single-line hint="Please choose the FOC item subcategory">
                      </v-select>
                    </v-form>
                  </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isEditFoc = false"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="editItemFoc"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="isEditDetail"
        persistent
        width="800px"
        max-width="800px"
      >
      <v-card>
        <v-card-title>
          <span class="text-h5">Edit Detail</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" md="2">
                <v-text-field
                  v-on:change="editOnChangeDetail($event, 'detailrank')"
                  :value="editdetail.detailrank"
                  class="mb-4"
                  placeholder="Num"
                  type="number"
                  oninput="if(this.value < 1) this.value = 1;"
                  single-line
                  hint="Num"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="8">
                <v-file-input outlined dense label="File input" v-on:change="onDetailFileChange" accept="image/*" />     
              </v-col>
              <v-col cols="12" md="12">
                 <vue-editor
                  v-model="editdetail.detailbody"
                  @text-change="editOnChangeDetail(editdetail.detailbody, 'detailbody')"
                  :value="editdetail.detailbody"
                 ></vue-editor>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="isEditDetail = false"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="editItemDetail"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
  </v-container>
</template>

<script>
import {VueEditor} from "vue2-editor";
import {mapActions, mapState} from "vuex";
import router from '@/Routes';
import ImageEditView from "@/pages/Image/Components/ImageEditView.vue";

export default {
  components: {
    VueEditor,
    ImageEditView
  },
  computed: {
    ...mapState('Brand', ['brands']),
    ...mapState('Item', ['items', 'isReceiving']),
    ...mapState('ItemCategory', ['itemcategories']),
    ...mapState('ItemGroup', ['itemgroups']),
    ...mapState('ItemSubcategory', ['itemsubcategories']),
    ...mapState('PriceList', ['pricelists']),
  },
  data () {
    return {
      isAddDetail: false,
      isAddPrice: false,
      isDeleteDetail: false,
      isDeletePrice: false,
      isEditDetail: false,
      isEditPrice: false,
      isEditFoc: false,
      haserror: false,
      imageurl: undefined,
      filename: null,
      uploadname: null,
      error: undefined,
      errorindex: undefined,
      
      edit_item: {},
      change_item: {},
      detail: {},
      price: {},
      addprice: {},
      foc: {},
      deletedetail: {},
      deleteprice: {},
      editdetail: {},
      editprice: {},
      editfoc: {foc: {}},
      photo: {},
      upload: {},
      initvalue: {},
      footer: {'items-per-page-options': [500, 1000, 5000]},
      images: [],
      itemdetails: [],
      itemprices: [],
      itemtype: ['Item', 'Gift Item', 'Other Item'],
      foctype: ['Item', 'Subcategory Item'],
      units: ['Bag', 'Bot', 'Box', 'Ctn', 'Doz', 'Pak'],
      detailHeaders: [
        { text: "#", value: "detailrank", width: "10px" },
        { text: "Detail", value: "detailbody" },
        { text: "Created", value: "createdAt", width: "10%" },
        { text: "Actions", value: "actions", sortable: false, width: "10%" },
      ],
      priceHeaders: [
        { text: 'Item', value: 'itemid', width: '15%', sortable: false },
        { text: 'Price List', value: 'pricelistid', width: '15%', sortable: false },
        { text: 'Min Max Qty', value: 'minqty', width: '10%' },
        { text: 'Price', value: 'listprice', width: '10%'},
        { text: 'Foc', value: 'foc' },
        { text: 'Create', value: 'createdAt' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
    }
  },
  methods: {
    ...mapActions('Item', ['deleteItemDetailRequest', 'getItemsRequest', 'insertItemDetailRequest', 'updateItemRequest','updateItemImageRequest','updateItemDetailRequest','getItemsRequest']),
    ...mapActions('Brand', ['getBrandsRequest']),
    ...mapActions('ItemCategory', ['getItemCategoriesRequest']),
    ...mapActions('ItemGroup', ['getItemGroupsRequest']),
    ...mapActions('ItemSubcategory', ['getItemSubcategoriesRequest']),
    ...mapActions('Price', ['deletePriceRequest', 'insertPriceRequest', 'updatePriceRequest', 'updateFocRequest']),
    ...mapActions('PriceList', ['getPriceListsRequest']),
    addPriceDialog() {
      this.addprice = {};
      this.isAddPrice = true;
    },
    async addPrice() {
      if(!this.checkPrice()) return;
      this.isAddPrice = false;
      this.addprice.itemid = this.initvalue._id;
      let response = await this.insertPriceRequest(this.addprice);
      this.itemprices.push(response);
      this.addprice = {};
    },
    async addItemDetail() {
      this.isAddDetail = false;
      this.detail.itemid = this.initvalue._id;
      let result = await this.insertItemDetailRequest(this.detail);
      this.itemdetails.push(result);
      this.detail = {};
    },
    checkPrice(){
      if(!this.addprice.pricelistid){
        this.haserrors = true;
        this.errorindex = 20;
        return false;
      }
      if(!this.addprice.pricename){
        this.haserrors = true;
        this.errorindex = 21;
        return false;
      }
      if(!this.addprice.currency){
        this.haserrors = true;
        this.errorindex = 22;
        return false;
      }
      if(!this.addprice.unit){
        this.haserrors = true;
        this.errorindex = 23;
        return false;
      }
      if(!this.addprice.minqty){
        this.haserrors = true;
        this.errorindex = 24;
        return false;
      }
      if(!this.addprice.maxqty){
        this.haserrors = true;
        this.errorindex = 25;
        return false;
      }
      if(!this.addprice.listprice){
        this.haserrors = true;
        this.errorindex = 26;
        return false;
      }
      this.errorindex = -1;
      this.step = 2;
      return true;
    },
    deleteDetailDialog(item) {
      this.isDeleteDetail = true;
      this.deletedetail = {
        _id: item._id,
        detailrank: item.detailrank,
      };
    },
    deletePriceDialog(item) {
      this.isDeletePrice = true;
      this.deleteprice = {
        _id: item._id,
        pricename: item.pricename,
      };
    },
    async deleteDetail(payload) {
      this.isDeleteDetail = false;
      let response = await this.deleteItemDetailRequest(payload);
      let index = this.itemdetails.findIndex((detail) => detail._id == response._id);
      this.itemdetails.splice(index, 1);
    },
    async deletePrice(payload) {
      this.isDeletePrice = false;
      let response = await this.deletePriceRequest(payload);
      let index = this.itemprices.findIndex((price) => price._id == response._id);
      this.itemprices.splice(index, 1);
    },
    editDetailRequest(item) {
      this.detail = {};
      this.editdetail = {};
      this.isEditDetail = true;
      this.editdetail = Object.assign({}, item);
    },
    async editItemDetail() {
      this.isEditDetail = false;
      this.detail.itemdetailid = this.editdetail._id;
      let response = await this.updateItemDetailRequest(this.detail);
      let index = this.itemdetails.findIndex((detail) => detail._id == response._id);
      this.itemdetails.splice(index, 1, response);
      this.editdetail = {};
    },
    editItemPriceDialog(item) {
      this.editprice = {};
      this.price = {};
      this.isEditPrice = true;
      this.editprice = Object.assign({}, item);
    },
    editItemFocDialog(item) {
      this.editfoc = {};
      this.foc = {};
      this.isEditFoc = true;
      this.editfoc = Object.assign({}, item);
    },
    async editItemPrice() {
      this.isEditPrice = false;
      this.price._id = this.editprice._id;
      console.log(this.price);
      let response = await this.updatePriceRequest(this.price);
      console.log("here", response._id);
      let index = this.itemprices.findIndex((price) => price._id == response._id);
      console.log(index);
      this.itemprices.splice(index, 1, response);
      this.editprice = {};
    },
    async editItemFoc() {
      this.isEditFoc = false;
      this.foc._id = this.editfoc._id;
      console.log(this.foc);
      let response = await this.updateFocRequest(this.foc);
      console.log("here", response._id);
      let index = this.itemprices.findIndex((price) => price._id == response._id);
      console.log(index);
      this.itemprices.splice(index, 1, response);
      this.editfoc = {foc: {}};
    },
    editOnChangeDetail(value, field){
      this.detail[field] = value;
    },
    editOnChangePrice(value, field){
      this.price[field] = value;
    },
    editOnChangeFoc(value, field){
      this.foc[field] = value;
    },
    async editItem() {
      this.change_item._id = this.initvalue._id;
      await this.updateItemRequest(this.change_item);
      this.getItemsRequest();
      router.push('/item/list');
    },
    editDetail() {
      this.detail._id = this.initvalue._id;
      this.updateItemRequest(this.detail);
      this.getItemsRequest();
      router.push('/item/list');
    },
    editPhoto() {
      this.photo._id = this.initvalue._id;
      this.updateItemImageRequest(this.photo);
      this.getItemsRequest();
      router.push('/item/list');
    },
    updateChangedValue(value, field){
      this.change_item[field] = value;
    },
    updateChangedDetail(value, field){
      console.log(value, field);
      this.detail[field] = value;
    },
    onFileChange(file) {
      if (!file) {return;}
      this.photo.itemimage = file;
      this.photo.imagename = file.name;
      const reader = new FileReader();
      reader.onload = e => {
        this.imageurl = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    onUploadChange(file) {
      if (!file) {return;}
      this.upload.itemimage = file;
      this.upload.imagename = file.name;
    },
    onDetailFileChange(file) {
      if (!file) {return;}
      this.detail.detailimage = file;
      this.detail.imagename = file.name;
    },

  },
  async created () {
    this.initvalue = this.$route.params;
    this.edit_item = Object.assign({}, this.initvalue);
    if(!this.initvalue._id) this.$router.push({ name: 'ItemList' });
    this.imageurl = this.initvalue.itemimage;
    this.images = this.initvalue.itemimages;
    this.itemdetails = this.initvalue.details;
    this.itemprices = this.initvalue.prices;
    if(this.brands.length==0) await this.getBrandsRequest();
    if(this.items.length==0) await this.getItemsRequest();
    if(this.itemcategories.length==0) await this.getItemCategoriesRequest();
    if(this.itemgroups.length==0) await this.getItemGroupsRequest();
    if(this.itemsubcategories.length==0) await this.getItemSubcategoriesRequest();
    if(this.pricelists.length==0) await this.getPriceListsRequest();
  },
}
</script>

<style src="./Edit.scss" lang="scss"></style>
